import { render, staticRenderFns } from "./Heading.vue?vue&type=template&id=225b99fe&scoped=true&lang=pug"
import script from "./Heading.vue?vue&type=script&lang=js"
export * from "./Heading.vue?vue&type=script&lang=js"
import style0 from "./Heading.vue?vue&type=style&index=0&id=225b99fe&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225b99fe",
  null
  
)

export default component.exports